import { Stack } from "@mui/material";
import { Button } from "@/components/elements/Button";
import { AppRoutes } from "@/routes/config";
import { useNavigate } from "react-router-dom";
import { FC, useMemo } from "react";
import { getDynamicRoute } from "@/utils/url";
import { FooterContainer } from "@/components/commons/FooterContainer";
import { useMatchListSessionStorage } from "@/hooks/useMatchListSessionStorage";

type TCompanyFooterContainerProps = {
  matchId?: string;
  disabled?: boolean;
};
export const MatchFooterContainer: FC<TCompanyFooterContainerProps> = ({ matchId, disabled }) => {
  const navigate = useNavigate();
  const { getBackUrl } = useMatchListSessionStorage();
  const editRoute = getDynamicRoute(AppRoutes.matchEdit, { id: matchId });
  const backUrl = useMemo(() => getBackUrl(), [getBackUrl]);

  return (
    <FooterContainer>
      <Stack gap={1} direction="row" justifyContent="space-between" alignItems="center">
        <Button variant="secondary" onClick={() => navigate(backUrl)}>
          戻る
        </Button>
        <Button type="button" variant="primary" size="sm" onClick={() => navigate(editRoute)} disabled={disabled}>
          編集
        </Button>
      </Stack>
    </FooterContainer>
  );
};
